import { PaginationResponseParams } from '@Pages/RetroSynthesis/constants';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';
import get from 'lodash/get';
import isArray from 'lodash/isArray';

const mapPublishedResponse = (response) => {
  // eslint-disable-next-line no-unused-vars
  const { content, totalPages, totalElements, number, size } = isArray(response) ? response[0] : response;

  return {
    content: isUndefined(content) ? [] : map(get(content, [0, 'entities']), (entity) => entity),
    [PaginationResponseParams.PAGE_NUMBER]: number || 0,
    [PaginationResponseParams.SIZE]: size || 10,
    [PaginationResponseParams.TOTAL_ELEMENTS]:
      (response.content && response.content[0] && response.content[0].totalResultSize) || totalElements || 0,
    [PaginationResponseParams.TOTAL_PAGES]: totalPages || 5,
  };
};

export default mapPublishedResponse;
